import React, { useContext, useEffect, useState } from 'react'
import '../Home/Home.css'
import { AuthContext } from '../../context/AuthContext'
import { doc, onSnapshot } from 'firebase/firestore'
import { db } from '../../config'
import { ChatContext } from '../../context/ChatContext'

const Chats = () => {
  const { curUser } = useContext(AuthContext)
  const { dispatch } = useContext(ChatContext)
  const [chats, setChats] = useState([])

  useEffect(() => {
    const getChats = () => {
      const unsubmit = onSnapshot(doc(db, 'usergroups', curUser.uid), (doc) => {
        setChats(doc.data())
      })

      return () => {
        unsubmit()
      }
    }

    curUser.uid && getChats()
  }, [curUser.uid])

  const handleSelect = (chat) => {
    dispatch({ type: 'CHANGE_GROUP', payload: chat })
  }

  return (
    <div className="chats">
      {Object.entries(chats)?.map((chat) => (
        <div
          className="groupChat"
          key={chat[0]}
          onClick={() => handleSelect(chat)}
        >
          <span>{chat[1].groupInfo.groupName}</span>
        </div>
      ))}
    </div>
  )
}

export default Chats
